import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface UserDevices{
    alias: string
    createdAt: string
    device_id: number
    is_active: boolean
    updatedAt ? : string
    user_id: number
}

export interface Devices {
    deviceId: string
    category_id: number
    createdAt: string
    id: number
    updatedAt ? : string
    UserDevices : UserDevices
}

interface Readings {
    "mm/hg" ?  : string,
    "mg/dl"  ? : string,
    "bpm" ? : string,
    "SPO2" ?  : string,
}


export interface Categories{
    id : number,
    logo : string,
    name : string,
    readings  : Readings
}

const devices: Devices[] = JSON.parse(localStorage.getItem('devices')!) || []

const categories : Categories[] = JSON.parse(localStorage.getItem('categories')!) || []

const distinctDevices: Devices[] = JSON.parse(localStorage.getItem('distinctDevices')!) || []

export const userSlice = createSlice({
    name: 'user',
    initialState:{
        devices : devices,
        categories : categories,
        distinctDevices: distinctDevices
    },
    reducers: {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes

        setInitialDevices: (state,action:PayloadAction<Devices[]>) => {
            state.devices = action.payload
        },
        setInitialDistinctDevices: (state,action:PayloadAction<Devices[]>) => {
            state.distinctDevices = action.payload
        },
        addNewDevice: (state,action:PayloadAction<Devices>) => {
            state.devices.push(action.payload)
        },
        setInitialCategories: (state,action:PayloadAction<Categories[]>) => {
            state.categories = action.payload
        },
        resetUser: (state) => {
            state.devices = []
            state.categories = []
        },
    },
})

// Action creators are generated for each case reducer function
export const { setInitialDevices,setInitialCategories,addNewDevice,resetUser, setInitialDistinctDevices  } = userSlice.actions

export default userSlice.reducer